export const getMenuItemForInstore = (
  menuItem,
  menuItemSizes,
  menuItemSubModifiers,
  shouldUpdateSingleSize = true
) => {
  let currentItemObj = { ...menuItem };

  if (
    currentItemObj.itemType === 0 &&
    currentItemObj.selectedSizes &&
    currentItemObj.selectedSizes.length > 0
  ) {
    let isSingleSize = currentItemObj.selectedSizes.length === 1 ? true : false;

    // Find instore price for each size and update in current menu item
    currentItemObj.selectedSizes.map((size) => {
      let matchingSizePrices = menuItemSizes.filter((f) => {
        return f.sizeId === size._id && f.variantId === 'xxx';
      });
      if (matchingSizePrices.length > 0 && matchingSizePrices[0].price) {
        size.price = matchingSizePrices[0].price;
      }
      if (size.variants) {
        size.variants = size.variants.map((v) => {
          let matchingSizeVariPrices = menuItemSizes.filter((f) => {
            return f.sizeId === size._id && f.variantId === v._id;
          });
          if (
            matchingSizeVariPrices.length > 0 &&
            matchingSizeVariPrices[0].price
          ) {
            v.price = matchingSizeVariPrices[0].price;
          }
          return v;
        });
      }
      if (shouldUpdateSingleSize) {
        size.isSingleSize = isSingleSize;
      }
      return size;
    });
  } else if (
    currentItemObj.itemType === 1 &&
    currentItemObj.selectedModifiers &&
    currentItemObj.selectedModifiers.length > 0
  ) {
    let isSingleSize = currentItemObj.selectedSizes.length === 1 ? true : false;

    // Find instore price for each size and update in current menu item
    currentItemObj.selectedSizes.map((size) => {
      let matchingSizePrices = menuItemSubModifiers.filter((f) => {
        return (
          f.subModifierId === size._id &&
          f.otherSubModifierId === 'xxx' &&
          f.variantId === 'xxx'
        );
      });
      if (matchingSizePrices.length > 0 && matchingSizePrices[0].price) {
        size.price = matchingSizePrices[0].price;
      }
      if (size.variants) {
        size.variants = size.variants.map((v) => {
          let matchingSizeVariPrices = menuItemSubModifiers.filter((f) => {
            return (
              f.subModifierId === size._id &&
              f.otherSubModifierId === 'xxx' &&
              f.variantId === 'xxx'
            );
          });
          if (
            matchingSizeVariPrices.length > 0 &&
            matchingSizeVariPrices[0].price
          ) {
            v.price = matchingSizeVariPrices[0].price;
          }
          return v;
        });
      }
      if (shouldUpdateSingleSize) {
        size.isSingleSize = isSingleSize;
      }
      return size;
    });
    currentItemObj.selectedModifiers.map((modifier) => {
      if (modifier.subModifiers) {
        if (modifier._id === currentItemObj.baseModifierId) {
          // Base modifier pricing structure
          let isSingleSize = modifier.subModifiers.length === 1 ? true : false;
          modifier.subModifiers.map((subModifier) => {
            let matchingSubModifierPrices = menuItemSubModifiers.filter((f) => {
              return (
                f.modifierId === modifier._id &&
                f.subModifierId === subModifier._id &&
                f.otherSubModifierId === 'xxx' &&
                f.variantId === 'xxx'
              );
            });
            if (
              matchingSubModifierPrices.length > 0 &&
              matchingSubModifierPrices[0].price
            ) {
              subModifier.price = matchingSubModifierPrices[0].price;
            }
            if (subModifier.variants) {
              subModifier.variants = subModifier.variants.map((v) => {
                let matchingSizeVariPrices = menuItemSubModifiers.filter(
                  (f) => {
                    return (
                      f.modifierId === modifier._id &&
                      f.subModifierId === subModifier._id &&
                      f.otherSubModifierId === 'xxx' &&
                      f.variantId === v._id
                    );
                  }
                );
                if (
                  matchingSizeVariPrices.length > 0 &&
                  matchingSizeVariPrices[0].price
                ) {
                  v.price = matchingSizeVariPrices[0].price;
                }
                return v;
              });
            }
            if (shouldUpdateSingleSize) {
              subModifier.isSingleSize = isSingleSize;
            }

            return subModifier;
          });
        } else {
          modifier.subModifiers.map((subModifier) => {
            if (subModifier.prices) {
              subModifier.prices.map((price) => {
                let matchingSubModifierPrices = menuItemSubModifiers.filter(
                  (f) => {
                    return (
                      f.modifierId === modifier._id &&
                      f.subModifierId === subModifier._id &&
                      f.otherSubModifierId === price._id &&
                      f.variantId === 'xxx'
                    );
                  }
                );
                if (
                  matchingSubModifierPrices.length > 0 &&
                  matchingSubModifierPrices[0].price
                ) {
                  subModifier.price = matchingSubModifierPrices[0].price;
                  price.price = matchingSubModifierPrices[0].price;
                }
                if (subModifier.variants) {
                  subModifier.variants = subModifier.variants.map((v) => {
                    let matchingSizeVariPrices = menuItemSubModifiers.filter(
                      (f) => {
                        return (
                          f.modifierId === modifier._id &&
                          f.subModifierId === subModifier._id &&
                          f.otherSubModifierId === price._id &&
                          f.variantId === v._id
                        );
                      }
                    );
                    if (
                      matchingSizeVariPrices.length > 0 &&
                      matchingSizeVariPrices[0].price
                    ) {
                      v.price = matchingSizeVariPrices[0].price;
                    }
                    return v;
                  });
                }

                return price;
              });
            }

            return subModifier;
          });
        }
      }
      return modifier;
    });
  }

  return currentItemObj;
};

export const getMinifiedMenuItemForInstore = (
  menuItem,
  menuItemSizes,
  menuItemSubModifiers,
  orderType,
  shouldUpdateSingleSize = true
) => {
  let currentItemObj = { ...menuItem };

  if (
    currentItemObj.itemType === 0 &&
    currentItemObj.selectedSizes &&
    currentItemObj.selectedSizes.length > 0
  ) {
    let isSingleSize = currentItemObj.selectedSizes.length === 1 ? true : false;

    // Find instore price for each size and update in current menu item
    currentItemObj.selectedSizes.map((size) => {
      let matchingSizePrices = menuItemSizes.filter((f) => {
        return f.sizeId === size._id && f.variantId === 'xxx';
      });
      if (
        matchingSizePrices.length > 0 &&
        matchingSizePrices[0].orderTypes[orderType]
      ) {
        size.price = matchingSizePrices[0].orderTypes[orderType];
      }
      if (size?.variants?.length > 0) {
        size.variants = size.variants.map((v) => {
          let matchingSizeVariPrices = menuItemSizes.filter((f) => {
            return f.sizeId === size._id && f.variantId === v._id;
          });
          if (
            matchingSizeVariPrices.length > 0 &&
            matchingSizeVariPrices[0].orderTypes[orderType]
          ) {
            v.price = matchingSizeVariPrices[0].orderTypes[orderType];
          }
          return v;
        });
      }
      if (shouldUpdateSingleSize) {
        size.isSingleSize = isSingleSize;
      }
      return size;
    });
  } else if (
    currentItemObj.itemType === 1 &&
    currentItemObj.selectedModifiers &&
    currentItemObj.selectedModifiers.length > 0
  ) {
    let isSingleSize = currentItemObj.selectedSizes.length === 1 ? true : false;

    // Find instore price for each size and update in current menu item
    currentItemObj.selectedSizes.map((size) => {
      let matchingSizePrices = menuItemSubModifiers.filter((f) => {
        return (
          f.subModifierId === size._id &&
          f.otherSubModifierId === 'xxx' &&
          f.variantId === 'xxx'
        );
      });
      if (
        matchingSizePrices.length > 0 &&
        matchingSizePrices[0].orderTypes[orderType]
      ) {
        size.price = matchingSizePrices[0].orderTypes[orderType];
      }
      if (size.variants) {
        size.variants = size.variants.map((v) => {
          let matchingSizeVariPrices = menuItemSubModifiers.filter((f) => {
            return (
              f.subModifierId === size._id &&
              f.otherSubModifierId === 'xxx' &&
              f.variantId === 'xxx'
            );
          });
          if (
            matchingSizeVariPrices.length > 0 &&
            matchingSizeVariPrices[0].orderTypes[orderType]
          ) {
            v.price = matchingSizeVariPrices[0].orderTypes[orderType];
          }
          return v;
        });
      }
      if (shouldUpdateSingleSize) {
        size.isSingleSize = isSingleSize;
      }
      return size;
    });
    currentItemObj.selectedModifiers.map((modifier) => {
      if (modifier.subModifiers) {
        if (modifier._id === currentItemObj.baseModifierId) {
          // Base modifier pricing structure
          let isSingleSize = modifier.subModifiers.length === 1 ? true : false;
          modifier.subModifiers.map((subModifier) => {
            let matchingSubModifierPrices = menuItemSubModifiers.filter((f) => {
              return (
                f.modifierId === modifier._id &&
                f.subModifierId === subModifier._id &&
                f.otherSubModifierId === 'xxx' &&
                f.variantId === 'xxx'
              );
            });
            if (
              matchingSubModifierPrices.length > 0 &&
              matchingSubModifierPrices[0].orderTypes[orderType]
            ) {
              subModifier.price =
                matchingSubModifierPrices[0].orderTypes[orderType];
            }
            if (subModifier.variants) {
              subModifier.variants = subModifier.variants.map((v) => {
                let matchingSizeVariPrices = menuItemSubModifiers.filter(
                  (f) => {
                    return (
                      f.modifierId === modifier._id &&
                      f.subModifierId === subModifier._id &&
                      f.otherSubModifierId === 'xxx' &&
                      f.variantId === v._id
                    );
                  }
                );
                if (
                  matchingSizeVariPrices.length > 0 &&
                  matchingSizeVariPrices[0].orderTypes[orderType]
                ) {
                  v.price = matchingSizeVariPrices[0].orderTypes[orderType];
                }
                return v;
              });
            }
            if (shouldUpdateSingleSize) {
              subModifier.isSingleSize = isSingleSize;
            }

            return subModifier;
          });
        } else {
          modifier.subModifiers.map((subModifier) => {
            if (subModifier.prices) {
              subModifier.prices.map((price) => {
                let matchingSubModifierPrices = menuItemSubModifiers.filter(
                  (f) => {
                    return (
                      f.modifierId === modifier._id &&
                      f.subModifierId === subModifier._id &&
                      f.otherSubModifierId === price._id &&
                      f.variantId === 'xxx'
                    );
                  }
                );
                if (
                  matchingSubModifierPrices.length > 0 &&
                  matchingSubModifierPrices[0].orderTypes[orderType]
                ) {
                  subModifier.price =
                    matchingSubModifierPrices[0].orderTypes[orderType];
                  price.price =
                    matchingSubModifierPrices[0].orderTypes[orderType];
                }
                if (subModifier.variants) {
                  subModifier.variants = subModifier.variants.map((v) => {
                    let matchingSizeVariPrices = menuItemSubModifiers.filter(
                      (f) => {
                        return (
                          f.modifierId === modifier._id &&
                          f.subModifierId === subModifier._id &&
                          f.otherSubModifierId === price._id &&
                          f.variantId === v._id
                        );
                      }
                    );
                    if (
                      matchingSizeVariPrices.length > 0 &&
                      matchingSizeVariPrices[0].orderTypes[orderType]
                    ) {
                      v.price = matchingSizeVariPrices[0].orderTypes[orderType];
                    }
                    return v;
                  });
                }

                return price;
              });
            }

            return subModifier;
          });
        }
      }
      return modifier;
    });
  }

  return currentItemObj;
};
